import React, { useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import { PlusIcon } from '@heroicons/react/20/solid';
import AddNewShippingForm from './AddNewShippingForm';
import { useAuth } from '../../portal/context/auth-context';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function ShippingInformation({ isShowing, setIsShowing, setShowShipping, showShipping }) {
    const [newShipping, setNewShipping] = useState(false);
    const { currentUser, updateCurrentUser } = useAuth();

    const [shippingInfoState, setShippingInfoState] = useState(currentUser?.shipAddresses || []);
    const [selectedShipping, setSelectedShipping] = useState(currentUser?.selectedShipAddress || null);

    useEffect(() => {
        setShippingInfoState(currentUser?.shipAddresses || []);
        setSelectedShipping(currentUser?.selectedShipAddress || null);
    }, [currentUser]);

    const handleSubmit = (id) => {
        setShowShipping(!showShipping);

        const selected = (shippingInfoState || []).find((item) => item.shipAddressId === id);
        if (!selected) return;

        setSelectedShipping(selected);

        updateCurrentUser({
            ...currentUser,
            selectedShipAddress: selected,
        });
    };

    useEffect(() => {
        window.scrollTo(0, document.body.scrollHeight);
    }, [showShipping]);

    const handleNewAddress = (newAddress) => {
        shippingInfoState.map((item) => {
            if (item.selected) {
                item.selected = false;
            }
        });

        setShippingInfoState((prevState) => {
            return [...prevState, newAddress];
        });
        setNewShipping(!newShipping);
    };

    return (
        <>
            <Transition
                appear={true}
                show={isShowing}
                enter='ease-in-out'
                enterFrom='translate-x-full opacity-0'
                enterTo='translate-x-0 opacity-100'
                leave='ease-out'
                leaveFrom='translate-x-0 opacity-100'
                leaveTo='translate-x-full opacity-0'
            >
                <div className='px-4 py-5 mt-6 border-2 border-gray-200 sm:p-6'>
                    <div className='mt-4'>
                        <h3 className='text-xl font-medium leading-6 text-gray-900'>Shipping Information</h3>

                        {!showShipping && (
                            <div className='mt-2'>
                                <p className='text-sm text-gray-500'>
                                    Please select the shipping information you would like to use for this order.
                                </p>
                                <div className='mt-12'>
                                    <div className='flex flex-row justify-between'>
                                        <div className='-my-2 sm:-mx-6 lg:-mx-8'>
                                            <div className='flex flex-col flex-wrap justify-start py-2 pl-6 w-full md:flex-row'>
                                                {!showShipping &&
                                                    Array.isArray(shippingInfoState) &&
                                                    shippingInfoState.map((info) => (
                                                        <div
                                                            onClick={() => {
                                                                setShippingInfoState(
                                                                    shippingInfoState.map((item) => {
                                                                        if (item.shipAddressId === info.shipAddressId) {
                                                                            return { ...item, selected: true };
                                                                        } else {
                                                                            return { ...item, selected: false };
                                                                        }
                                                                    })
                                                                );
                                                                setNewShipping(false);
                                                                handleSubmit(info.shipAddressId);
                                                            }}
                                                            key={info.shipAddressId}
                                                            className={classNames(
                                                                info.selected ? '' : 'bg-white text-gray-900',
                                                                'shadow-md border cursor-pointer sm:rounded-md w-64 hover:-translate-y-1 transform transition-all duration-300 mx-1 my-2 p-3 flex flex-col justify-center items-start'
                                                            )}
                                                        >
                                                            <div className='px-1 pt-6 pb-4 mt-2'>
                                                                <h3 className='font-medium leading-4 text-gray-900 text-md'>
                                                                    {info.shipAddressName}
                                                                </h3>
                                                                <p className='mt-2 text-sm text-gray-600'>{info.street}</p>
                                                                <p className='text-sm text-gray-600'>
                                                                    {info.city}, {info.state} {info.zip}
                                                                </p>
                                                                <p className='text-sm text-gray-600'>
                                                                    {info.postalCode}, {info.country}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ))}

                                                {!newShipping && !showShipping && (
                                                    <div
                                                        onClick={() => {
                                                            setNewShipping(!newShipping);
                                                        }}
                                                        className='flex flex-col justify-around p-3 mx-1 my-2 w-64 text-gray-900 bg-white border shadow-md transition-all duration-300 transform cursor-pointer sm:rounded-md hover:-translate-y-1'
                                                    >
                                                        <div className='flex flex-col justify-center items-center px-4 py-5 sm:px-6'>
                                                            <h3 className='text-lg font-medium leading-6 text-gray-900'>
                                                                Add new
                                                            </h3>
                                                            <PlusIcon className='w-20 h-20 text-blue-primary' />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {newShipping && (
                                            <AddNewShippingForm
                                                setNewShipping={setNewShipping}
                                                handleNewAddress={handleNewAddress}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {showShipping && selectedShipping && (
                        <div className='mt-4 ml-1 text-sm'>
                            <p>{selectedShipping.shipAddressName}</p>
                            <p> {selectedShipping.street} </p>
                            <p>
                                {selectedShipping.city}, {selectedShipping.state} {selectedShipping.zip}
                            </p>
                            <p>
                                {selectedShipping.postalCode}, {selectedShipping.country}
                            </p>
                        </div>
                    )}

                    <div className='mt-4'>
                        {!showShipping ? (
                            // <button
                            //   onClick={handleSubmit}
                            //   type="button"
                            //   disabled={selectedShipping === null}
                            //   className="inline-flex justify-center px-4 py-2 w-52 font-medium text-white rounded-md border border-transparent shadow-sm text-md bg-blue-primary hover:bg-blue-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary"
                            // >
                            //   <p>Next</p>
                            // </button>
                            <></>
                        ) : (
                            <button
                                onClick={() => {
                                    setShowShipping(!showShipping);
                                }}
                                type='button'
                                className='inline-flex justify-center px-4 py-2 font-medium bg-white rounded-md border shadow-sm border-blue-primary text-md text-blue-primary hover:bg-blue-primary hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary'
                            >
                                <p>Edit</p>
                            </button>
                        )}
                    </div>
                </div>
            </Transition>
        </>
    );
}
